import { render, staticRenderFns } from "./ConfirmSubmit.vue?vue&type=template&id=7d0e5080"
import script from "./ConfirmSubmit.vue?vue&type=script&lang=js"
export * from "./ConfirmSubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports